/** Turn API error payloads into a user-visible message (includes validation field errors when present). */
export function formatApiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  const data = (error as { response?: { data?: { error?: Record<string, unknown>; message?: string } } })
    ?.response?.data;
  const err = data?.error ?? data;
  if (!err || typeof err !== 'object') {
    return (error as Error)?.message || fallback;
  }

  const base =
    (typeof (err as { message?: string }).message === 'string' && (err as { message: string }).message) ||
    (typeof data?.message === 'string' ? data.message : '') ||
    fallback;

  const details = (err as { details?: unknown }).details;
  if (!details) return base;

  const items: Array<{ field?: string; message: string }> = [];

  if (Array.isArray(details)) {
    for (const row of details) {
      if (!row || typeof row !== 'object') continue;
      const r = row as { msg?: string; message?: string; path?: string; param?: string };
      const message = r.msg || r.message;
      if (!message) continue;
      const field = r.path || r.param;
      items.push({ field, message });
    }
  } else if (typeof details === 'object') {
    const d = details as { detail?: string; telnyxDetail?: string };
    if (typeof d.detail === 'string' && d.detail.trim()) {
      return `${base} — ${d.detail}`;
    }
  }

  if (typeof details === 'object' && Array.isArray((details as { errors?: unknown }).errors)) {
    for (const row of (details as { errors: unknown[] }).errors) {
      if (!row || typeof row !== 'object') continue;
      const r = row as { message?: string; field?: string };
      if (r.message) items.push({ field: r.field, message: r.message });
    }
  }

  if (items.length === 0) return base;

  const detailText = items
    .map((i) => (i.field ? `${i.field}: ${i.message}` : i.message))
    .join('; ');

  return `${base} — ${detailText}`;
}
